import plusImg from "./../assets/images/plus.png";
import noteImg from "./../assets/images/notes.png";
import doubleImg from "./../assets/images/double-tick.png";
import { useState } from "react";
import {
    useAddTodoMutation,
    useClearTodosMutation,
    useCompleteTodosMutation,
    useGetTodosQuery,
} from "../features/todo/api/todoApi";

export const Add = () => {
    const [text, setText] = useState("");
    const [apiAddTodo] = useAddTodoMutation();
    const [completeTodosApi] = useCompleteTodosMutation();
    const { data, isLoading, isError } = useGetTodosQuery();
    const [clearTodosApi] = useClearTodosMutation();

    // add todo in api
    const addSubmit = (e) => {
        e.preventDefault();
        const input = {
            text,
            completed: false,
        };
        apiAddTodo(input);
        setText("");
    };

    // all complete handler
    const completeHandler = () => {
        if (!isLoading && !isError) {
            data?.forEach((todo) => {
                if (!todo.completed) {
                    return completeTodosApi(Number(todo.id));
                }
            });
        }
    };

    // clear completed handler
    const clearCompleted = () => {
        if (!isLoading && !isError) {
            data?.forEach((todo) => {
                if (todo.completed) {
                    return clearTodosApi(Number(todo.id));
                }
            });
        }
    };

    return (
        <>
            <div>
                <form
                    onSubmit={addSubmit}
                    className="flex items-center bg-gray-100 px-4 py-4 rounded-md"
                >
                    <img src={noteImg} className="w-6 h-6" alt="Add todo" />
                    <input
                        type="text"
                        placeholder="Type your todo"
                        className="w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500"
                        required
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                    />
                    <button
                        type="submit"
                        className="appearance-none w-8 h-8 bg-no-repeat bg-contain"
                    >
                        <img src={plusImg} alt="icons" />
                    </button>
                </form>

                <ul className="flex justify-between my-4 text-xs text-gray-500">
                    <li
                        className="flex space-x-1 cursor-pointer"
                        onClick={completeHandler}
                    >
                        <img
                            className="w-4 h-4"
                            src={doubleImg}
                            alt="Complete"
                        />
                        <span>Complete All Tasks</span>
                    </li>
                    <li onClick={clearCompleted} className="cursor-pointer">
                        Clear completed
                    </li>
                </ul>
            </div>
        </>
    );
};
